export default "__VITE_ASSET__Du3rkB$P__"